import React, { useContext, useMemo } from 'react'
import ProductContext from '../context/ProductContext'
import { checkVariantAvailability, maybe } from '../../../utils/misc'
import ProductVariantsPicker from './ProductVariantsPicker'
import ProductFormButtons from './ProductFormButtons'
import { Button } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { getProductDashboardUrl } from '../../../urls'
import _ from 'lodash'
import ProductPrice from './ProductPrice'

const ProductVariantsForm: React.FC = () => {
  const { t } = useTranslation()
  const {
    selectedVariant,
    formValues,
    formMethods,
    onAddToBagFullKit,
    onAddToBag,
    onCustomizeKit,
    reflection,
    attributes,
    onDownloadFiles,
    me,
  } = useContext(ProductContext)
  const attrsByVariant = useMemo(() => {
    const allAttrs = maybe(() => reflection.product.variantsProperties, [])
    return _.groupBy(allAttrs, 'variation')
  }, [reflection?.product?.variantsProperties])

  return (
    <div className='product-variants-form relative'>
      {reflection && (
        <div>
          {reflection.product.isShippingRequired && (
            <>
              <ProductVariantsPicker
                attributes={attributes}
                selectedAttributes={formValues.selectedAttrs || {}}
                onChange={formMethods.setSelectedAttrs}
                attrsByVariant={attrsByVariant}
              />
            </>
          )}
          <ProductPrice />
          <ProductFormButtons
            checkVariantAvailability={() => checkVariantAvailability(selectedVariant)}
            selectedVariant={selectedVariant}
            onAddToBag={onAddToBag}
            onAddToBagFullKit={onAddToBagFullKit}
            onCustomizeKit={onCustomizeKit}
            isArchive={reflection?.product.isArchive}
            onDownloadFiles={() => {
              onDownloadFiles(reflection?.product.zipfileLink)
            }}
            zipFileLink={reflection?.product.zipfileLink}
            isInPack={reflection.product.isInPack}
          />
          {me?.isStaff && (
            <>
              <div className='my-5' />
              <Button
                variant='outlined'
                color='primary'
                size='medium'
                href={getProductDashboardUrl(reflection.product?.pk)}
                target='_blank'
                disableElevation
                fullWidth
              >
                {t('button.edit', 'Edit')}
              </Button>
            </>
          )}
        </div>
      )}
    </div>
  )
}

export default React.memo(ProductVariantsForm)
